import {
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_FAIL,
    FORGOT_PASSWORD_SUCCESS
} from './actionTypes';

export const forgotPassword = ({ email }) => ({
    type: FORGOT_PASSWORD,
    payload: { email }
});

export const forgotPasswordSuccess = () => ({
    type: FORGOT_PASSWORD_SUCCESS
});

export const forgotPasswordFail = error => ({
    type: FORGOT_PASSWORD_FAIL,
    payload: error
});
